import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { map } from 'lodash';
import styles from './barChart.module.scss';
import './barChartCustomStyles.css';

export default memo(function BarChart(props) {
    const [t] = useTranslation('dashboard');

    const series = map(props.series, serie => ({
        ...serie,
        name: t(serie.name)
    }));

    const chartOptions = {
        options: {
            chart: {
                animations: { speed: 1500 },
                stacked: true,
                toolbar: { show: false }
            },
            colors: ['#76bc21', '#409008', '#679634'],
            plotOptions: {
                bar: {
                    horizontal: false,
                    barHeight: '60%'
                }
            },
            stroke: {
                width: 1,
                colors: ['#ffffff']
            },
            xaxis: { categories: props.categories },
            tooltip: { enabled: false },
            fill: { opacity: 1 },
            legend: {
                itemMargin: {
                    horizontal: 5,
                    vertical: 10
                },
                offsetY: -20
            },
            dataLabels: { offsetY: 7 },
            yaxis: {
                min: 0,
                max: props.maxSum + 1 <= 5 ? 10 : props.maxSum + 1,
                labels: { offsetY: -3 }
            }
        },
        series: series
    };

    return (
        <div className={styles.container}>
            <Chart options={chartOptions.options} series={chartOptions.series} type="bar" height={props.height} />
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.height === nextProps.height &&
        prevProps.categories === nextProps.categories &&
        prevProps.series === nextProps.series
);
